import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@doger/ui/components/ui/select';
import { type AIModel, ModelToView } from '@doger/core/modules/chat';

import styles from './model-switcher.module.scss';

export type ModelSwitcherProps = {
  currentModel: AIModel;
  onModelChange: (model: AIModel) => void;
  disabled?: boolean;
};

const availableModels: AIModel[] = ['grok', 'gemini', 'open'];

export const ModelSwitcher = ({
  currentModel,
  onModelChange,
  disabled = false,
}: ModelSwitcherProps) => (
  <Select
    value={currentModel}
    onValueChange={(value: string) => {
      onModelChange(value as AIModel);
    }}
    disabled={disabled}
  >
    <SelectTrigger id='model-select' className={styles.modelSelector__trigger}>
      <SelectValue asChild>
        <span className={styles.modelSelector__value}>
          {ModelToView.toView(currentModel).name}
        </span>
      </SelectValue>
    </SelectTrigger>
    <SelectContent className={styles.modelSelector__content}>
      {availableModels.map((model) => {
        const { name, version } = ModelToView.toView(model);

        return (
          <SelectItem
            className={styles.modelSelector__item}
            key={model}
            value={model}
          >
            <span className={styles.modelSelector__itemContent}>
              <span>{name}</span>
              <span>{version}</span>
            </span>
          </SelectItem>
        );
      })}
    </SelectContent>
  </Select>
);
